import { translate, translateFormatter } from '@/domains/core/localization/translate';
export const {
  descriptionBasic,
  descriptionRecommended,
  descriptionStandard,
  titleBasic,
  titleRecommended,
  titleStandard
} = translate({
  "descriptionBasic": "The best on a budget and not a penny more",
  "descriptionRecommended": "If you want to make your neighbours jealous",
  "descriptionStandard": "Get fully kitted out without breaking the bank",
  "titleBasic": "Low price",
  "titleRecommended": "High quality",
  "titleStandard": "Best value for money"
});
export const ratingsCount = translateFormatter<{
  count: number;
}>([{
  "type": 0,
  "value": "from "
}, {
  "type": 6,
  "value": "count",
  "options": {
    "=1": {
      "value": [{
        "type": 7
      }, {
        "type": 0,
        "value": " review"
      }]
    },
    "other": {
      "value": [{
        "type": 7
      }, {
        "type": 0,
        "value": " reviews"
      }]
    }
  },
  "offset": 0,
  "pluralType": "cardinal"
}], undefined, undefined, "en");